
    import PageHeader from '../components/Layout/PageHeader.vue';

    export default {
        data() {
            return {
                loading: true,
                case_studies: []
            };
        },
        created() {
            this.fetchCaseStudies();
        },
        mounted() {
            //console.log('Component mounted.')
        },
        methods: {
            async fetchCaseStudies() {
                const result = await this.$axios.get("/casestudies");
                // .then(response => {
                //     this.case_studies = response.data.data;
                //     this.loading = false;
                // })
                this.case_studies = result.data.data;
                this.loading = false;
            }
        },
        components: { PageHeader }
    }
